// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1ZQzd","signatureButtonsRight":"ModalSign_signatureButtonsRight__3DHkn"};